import type { Prospect } from "../api/hooks";

import { dueLabel } from "./relativeTime";

// What a prospect's next action says, shared by the pipeline row and the panel
// opened from it.
//
// Written twice at first, and the two had already drifted: the row said "Due 3
// days late" for a date with no action while the panel said "Nothing planned"
// about the same prospect, which is the contradiction one screen away from the
// red row and the count that includes it.
export function nextActionLabel(prospect: Prospect): string {
  // A date with no action is still a date, and the row is drawn in red and
  // counted as overdue by the card above. Saying "Nothing planned" there leaves
  // an operator with a red row and a number they cannot account for.
  if (prospect.nextAction === "") {
    return prospect.nextActionAt === null
      ? "Nothing planned"
      : `Due ${dueLabel(prospect.nextActionAt)}`;
  }

  if (prospect.nextActionAt === null) return prospect.nextAction;

  // dueLabel, not sinceLabel: a follow-up is in the future, and "just now" is
  // what the past-tense one says about every date ahead of the clock.
  return `${prospect.nextAction}, ${dueLabel(prospect.nextActionAt)}`;
}

// Whether the next action reads as nothing at all, which is a different state
// from one that is planned or overdue and is drawn differently in both places.
export function hasNextAction(prospect: Prospect): boolean {
  return prospect.nextAction !== "" || prospect.nextActionAt !== null;
}
